import translateBase from '../translate';
import {events} from '../translate';

let translate = translateBase.bindComponent('dates');

function initDates() {
  DAY_NAMES_LONG.length = 0;
  DAY_NAMES_LONG.push(
    translate("sun", "Sunday"), 
    translate("mon", "Monday"), 
    translate("tue", "Tuesday"), 
    translate("wed", "Wednesday"),
    translate("thu", "Thursday"), 
    translate("fri", "Friday"), 
    translate("sat", "Saturday"),
  );
  
  DAY_NAMES_SHORT.length = 0;
  DAY_NAMES_SHORT.push(
    translate("suns", "Sun"), 
    translate("mons", "Mon"), 
    translate("tues", "Tue"), 
    translate("weds", "Wed"), 
    translate("thus", "Thu"), 
    translate("fris", "Fri"), 
    translate("sats", "Sat"),
  );
  
  MONTH_NAMES_LONG.length = 0;
  MONTH_NAMES_LONG.push(
    translate("jan", "January"), 
    translate("feb", "February"), 
    translate("mar", "March"), 
    translate("apr", "April"), 
    translate("may", "May"), 
    translate("jun", "June"), 
    translate("jul", "July"),
    translate("aug", "August"), 
    translate("sep", "September"), 
    translate("oct", "October"), 
    translate("nov", "November"), 
    translate("dec", "December"),
  );
  
  MONTH_NAMES_SHORT.length = 0;
  MONTH_NAMES_SHORT.push(
    translate("jans", "Jan"), 
    translate("febs", "Feb"), 
    translate("mars", "Mar"), 
    translate("aprs", "Apr"), 
    translate("mays", "May"), 
    translate("juns", "Jun"),
    translate("juls", "Jul"), 
    translate("augs", "Aug"), 
    translate("seps", "Sep"), 
    translate("octs", "Oct"), 
    translate("novs", "Nov"), 
    translate("decs", "Dec"),
  );
}

events.onTranslationsInited = initDates;


///===============================================================

export const DAY_NAMES_LONG = [
];

export const DAY_NAMES_SHORT = [
];

export const MONTH_NAMES_LONG = [
];

export const MONTH_NAMES_SHORT = [
];


// WEBPACK FOOTER //
// ./src/translate/dates.js